import React, { memo, useMemo } from 'react';
import { Grid } from '@mui/material';
import { useGetMyAnalyticsData } from 'modules/Insights/Notes/hooks/useGetMyAnalyticsData';
import { LabelType, MyAnalyticsDimensionType } from 'graphql/types';
import { transformLabelData } from './utils';
import ActivityComponent from './ActivityComponent';

export const ActivityChart: React.FC = () => {
  const { data, loading = true, isEmpty } = useGetMyAnalyticsData(
    MyAnalyticsDimensionType.MetricsByActivity
  );

  const dataset = useMemo(() => {
    if (isEmpty) {
      return [];
    } else {
      return transformLabelData(data?.myAnalytics?.items, LabelType.Activity);
    }
  }, [data?.myAnalytics?.items, isEmpty]);

  return (
    <Grid>
      <ActivityComponent data={dataset} loading={loading} isEmpty={isEmpty} />
    </Grid>
  );
};
export default memo(ActivityChart);
